<template>
    <el-card class="page_card" ref="card" v-loading="!is_ok">
        <div slot="header" class="clearfix">
            <span>企业余额表</span>
        </div>
        <el-form inline :model="selectForm" ref="selectForm">
            <el-form-item label="企业名称/简称">
                <el-select
                    v-model="selectForm.comId"
                    :multiple="false"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请输入企业名称/简称"
                    @change="changeCom">
                    <el-option
                        v-for="item in componys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="">
                <el-button plain type="primary" @click="selectSubmit()">查 询</el-button>
                <el-button plain @click="resetSelect()">重 置</el-button>
                <el-button plain type="success" @click="exportExcel"> <svg-icon icon-class="xls" /> 导出到excel</el-button>
            </el-form-item>
        </el-form>
        <el-table ref="table" :data="list" :max-height="tableMaxHeight">
            <el-table-column label="企业名称" width="" align="center">
                <template slot-scope="scope">
                    <span class="primary_text">{{scope.row.comName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="信用额度(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.credit)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="当前余额(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.actualBalance)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="冻结资金(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.freezeBalance)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="企业总余额(元)" width="" align="right">
                <template slot-scope="scope">
                    <span class="primary_text">{{parseNums(scope.row.balance)}}</span>
                </template>
            </el-table-column>
        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :hide-on-single-page="false"
                layout="total, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>
    </el-card>
</template>
<script>
import request from '@/utils/request'
import defaultSetting from '@/settings'
import {getToken} from '@/utils/auth'
export default {
    name:'customer_balance_sheet',
    data(){
        return{
            is_ok:false,
            componys:[],
            selectForm:{
                comId:'',
                pageNum:1,
                pageSize:15
            },
            tableMaxHeight:0,
            total:0,
            list:[],
            baseUrl:''
        }
    },
    methods:{
        resetSelect(){
            this.selectForm = {
                pageNum:1,
                pageSize:15,
                comId:"",
            };
            this.$refs["selectForm"].resetFields();
            this.getData();
        },
        selectSubmit(){
            this.getData();
        },
        changeCom(e){
            this.selectForm.comId=e;
            this.getData();
        },
        getCompany(){
            request.get("company/option").then(res=>{
                this.componys = res.data;
                this.componys.push( {id:"",name:"全部"})
            }).catch(err=>{
            });
        },
        getData(){
            request.post("report/company/money",this.selectForm).then(res=>{
                this.list = res.data.list;
                this.total = res.data.total;
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-135;
            }).catch(err=>{
                this.is_ok = true;
                this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-135;
            });
        },
        //分页改变
        pageChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        //保存到excel文件中
        async exportExcel(){
            try{
                let res = await fetch(this.baseUrl+"/report/customer_balance/excel",{
                    method:"POST",
                    headers:{
                        "Authorization":getToken(),
                        "Content-Type":"application/json;charset=utf-8"
                    },
                    body:JSON.stringify(this.selectForm)
                });
                let blob = await res.blob();
                const a= document.createElement("a")
                a.href = URL.createObjectURL(blob)
                a.download = "企业余额表.xls"
                a.click()
                URL.revokeObjectURL(a.href)
                this.$message.success("导出成功!");
            }catch(err){
            }finally {
            }
        },
        parseNums(n,is_int=false) {
            //转化成字符串
            let str = n.toString();
            //若是整数自动补全小数位
            if (-1 == str.indexOf(".")) {
                str = str + ".00"
            }
            if(str.indexOf(".")!=-1){
                let x = str.indexOf('.') + 1;   //小数点的位置
                let y = str.length - x;  //小数的位数
                if(y > 0 && y == 1){
                    str = str + "0"
                }
            }
            //全部替换
            if (-1 != str.indexOf(",")) {
                str = str.replace(new RegExp(',', "g"), "")
            }
            let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
            if(is_int){
                return intSum;
            }
            let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
            let ret = intSum + dot;
            return ret;
        },
    },
    created(){
        this.baseUrl = process.env.VUE_APP_BASE_API+"/"+defaultSetting.api_version;
    },
    mounted(){
        this.getData();
        this.getCompany();
    }
}
</script>
<style scoped lang="scss">

</style>
